import React from "react";

const XLS = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M22.368 2H6v32h23.344V11.491l-8.293-5.726L22.368 2zm-8.986 19.78l-.704-1.407c-.288-.543-.473-.946-.692-1.397h-.021c-.163.451-.359.854-.602 1.397l-.646 1.408H8.712l2.25-3.936-2.17-3.84h2.02l.68 1.417c.231.474.404.855.588 1.293h.022c.186-.496.336-.841.532-1.293l.657-1.419H15.3L13.107 17.8l2.307 3.98H13.382zm10.808-3.265c-1.29-.45-2.134-1.165-2.134-2.296 0-1.328 1.109-2.342 2.944-2.342.877 0 1.522.185 1.984.392l-.392 1.419a3.7 3.7 0 00-1.627-.368c-.762 0-1.13.346-1.13.749 0 .496.439.715 1.442 1.096 1.373.509 2.019 1.222 2.019 2.32 0 1.304-1.003 2.411-3.138 2.411-.888 0-1.764-.232-2.204-.474l.358-1.452a4.48 4.48 0 001.949.484c.808 0 1.235-.336 1.235-.843 0-.485-.37-.761-1.306-1.096zm-2.974 1.787v1.479H16.36v-7.776h1.766v6.299h3.092l-.002-.002z"
              fill={fill}
        />
        <path className="u_fill" d="M24.006 2L22.94 5.05l6.403 4.422L24.006 2z" fill={fill} />
    </svg>
);

export default XLS;
